import React from 'react';

import ReportController from '../../Components/ReportController';
import ExportContainer from '../../Components/ExportContainer';

import Conditions from '../../Data/dummy/Condition';
import Jurisdictions from '../../Data/dummy/Jurisdiction';
import ReportDisplay from '../../Components/ReportDisplay';
import { ReportControlBar } from '../../Components/ReportControlBar';
import { Button } from '../../../../components/Button';
import ReportBuilder from './builder';

const { FEATURE_REPORTS_NAVBAR_UI } = process.env;
class ConditionDetails extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.change = this.change.bind(this);
        this.updateOptions = this.updateOptions.bind(this);
        this.stepForward = this.stepForward.bind(this);
        this.stepBack = this.stepBack.bind(this);
        this.buildReport = this.buildReport.bind(this);
        this.exportRef = React.createRef();

        this.defaultReportContext = {
            condition: null,
            jurisdiction: null,
            userType: null,
            reportPrepared: false,
            reportSections: []
        };

        this.state = {
            step: 'jurisdiction',
            reportContext: this.defaultReportContext,
            selectOptions: [],
            displayState: 0
        };
    }

    componentDidMount() {
        this.updateOptions();
        // if (this.props.userContext.jurisdictionId != null) {
        //     let jurisdictionLabel = this.props.dataContext.jurisdiction[this.props.userContext.jurisdictionId];
        //     this.change({label: jurisdictionLabel, value: this.props.userContext.jurisdictionId}, true);
        // }
    }

    updateOptions() {
        let dummyOptions = this.state.step.charAt(0).toUpperCase() + this.state.step.substr(1);

        if (dummyOptions === 'Jurisdiction') {
            dummyOptions = Jurisdictions;
        } else if (dummyOptions === 'Condition') {
            dummyOptions = Conditions;
        }

        let selectOptions = Object.keys(dummyOptions).map((i) => {
            return {
                value: i,
                label: dummyOptions[i]
            };
        });
        this.setState({ selectOptions });
    }

    change(val, autostep = false) {
        if (val === null) {
            this.setState(
                {
                    reportContext: {
                        ...this.state.reportContext,
                        ...{
                            [this.state.step]: val,
                            complete: false
                        }
                    }
                },
                () => {
                    // Prepare available report context, or clear it
                }
            );
        } else {
            if (this.state.step === 'condition') {
                this.setState(
                    {
                        reportContext: {
                            ...this.state.reportContext,
                            ...{
                                [this.state.step]: val
                            }
                        }
                    },
                    () => {
                        // Prepare remaining report context
                        this.setState({
                            reportContext: {
                                ...this.state.reportContext,
                                ...{
                                    loading: true,
                                    complete: true
                                }
                            }
                        });
                        this.buildReport();
                    }
                );
            } else {
                this.setState(
                    {
                        reportContext: {
                            ...this.state.reportContext,
                            ...{
                                [this.state.step]: val
                            }
                        }
                    },
                    () => {
                        this.props.updateDataForJurisdictionId(val.value);
                        if (autostep) {
                            this.stepForward();
                        }
                    }
                );
            }
        }
    }

    buildReportContext() {
        let outputArray = [];

        outputArray.push(<div key={`context-${outputArray.length}`}>Selected Report Type: Condition Details</div>);

        if (this.state.reportContext.jurisdiction !== null && this.state.step === 'condition') {
            outputArray.push(
                <div key={`context-${outputArray.length}`}>
                    Selected Jurisdiction Scope: {this.state.reportContext.jurisdiction.label}
                </div>
            );
        }
        return outputArray;
    }

    stepForward() {
        this.setState({ step: 'condition' }, () => {
            this.updateOptions();
            if (this.state.reportContext.condition !== null && this.state.reportContext.jurisdiction !== null) {
                this.setState({
                    reportContext: {
                        ...this.state.reportContext,
                        ...{
                            complete: true,
                            loading: true
                        }
                    }
                });
                /*
                window.dataLayer.push({
                    event: 'reports_buildReport',
                    rckmsEventCategory: `Reports`,
                    rckmsEventAction: `Condition Details Jurisdiction Selected`,
                    rckmsEventLabel: `${this.state.reportContext.jurisdiction.label}`
                });
                */
            }
        });
    }
    //
    async buildReport() {
        let reportData = await this.props.fetchReportData('conditionDetails', this.state.reportContext);
        let report = ReportBuilder(reportData).build();

        // Make sure we haven't prematurely stepped back, in which case, don't set report state
        if (this.state.step == 'condition') {
            this.setState(
                {
                    reportContext: {
                        ...this.state.reportContext,
                        ...{ loading: false, complete: true, sections: report }
                    }
                },
                () => {
                    if (this.state.reportContext.condition !== null && this.state.reportContext.jurisdiction !== null) {
                        /*
                    window.dataLayer.push({
                        event: 'reports_buildReport',
                        rckmsEventCategory: `Reports`,
                        rckmsEventAction: `Generated Condition Details`,
                        rckmsEventLabel: `${this.state.reportContext.condition.label} for ${this.state.reportContext.jurisdiction.label}`
                    });
                    */
                    }
                }
            );
        } else {
            this.setState({ loading: false, complete: false });
        }
    }

    async downloadExcelReport() {
        this.props.handleReportPathSelect('condition-details-excel', this.state.reportContext);
    }

    stepBack() {
        if (this.state.step === 'condition') {
            this.setState(
                {
                    step: 'jurisdiction',
                    reportContext: {
                        ...this.state.reportContext,
                        ...{
                            complete: false,
                            condition: null
                        }
                    }
                },
                () => {
                    // Maybe clear condition setting
                    this.updateOptions();
                }
            );
        } else {
            this.props.back();
        }
    }

    render() {
        const isAdmin =
            typeof this.props.userContext == 'object' &&
            ['JURISDICTION_ADMINISTRATOR', 'RCKMS_ADMINISTRATOR'].includes(this.props.userContext.role);
        let selectOptions = { ...this.props.dataContext.jurisdiction };
        delete selectOptions.default;
        let actions =
            FEATURE_REPORTS_NAVBAR_UI !== 'true'
                ? [
                    {
                        label: 'Back',
                        display: true,
                        action: this.stepBack
                    },
                    {
                        label: 'Next',
                        display: this.state.reportContext.jurisdiction !== null && this.state.step === 'jurisdiction',
                        action: this.stepForward
                    },
                    {
                        label: 'Export Report',
                        display:
                            this.state.step === 'condition' &&
                            this.state.reportContext.complete &&
                            !this.state.reportContext.loading,
                        action: () => {
                            this.setState({ displayState: 1 });
                        }
                    }
                ]
                : [
                    {
                        label: 'Next',
                        display: this.state.reportContext.jurisdiction !== null && this.state.step === 'jurisdiction',
                        action: this.stepForward
                    }
                ];
        if (this.state.displayState === 0) {
            // RCKMSDEV-208
            let selectOptions = this.props.dataContext[this.state.step];
            if (this.state.step === 'condition') {
                // Map current values into workable objects
                let conditionNames = {};
                Object.values(selectOptions).map((combinedNameAndVersion, k) => {
                    const conditionId = Object.keys(selectOptions)[k];
                    const [name = '', version = ''] = combinedNameAndVersion.split('|', 2);
                    conditionNames[`C__${name.toUpperCase().trim()}`] = [
                        ...(conditionNames[`C__${name.toUpperCase().trim()}`] || []),
                        { conditionId, name: name.trim(), version: version.trim() }
                    ];
                });

                // Sort by condition name
                const sortedByConditionName = Object.keys(conditionNames).sort((a, b) =>
                    a.replace('C__', '').localeCompare(b.replace('C__', ''))
                );

                // Remap into improved object
                let conditionOptionsSorted = {};
                sortedByConditionName.map((sortedItem) => {
                    conditionNames[sortedItem]
                        .sort((a, b) => b.version.split(' ', 2)[0] - a.version.split(' ', 2)[0])
                        .map(({ conditionId, name, version }) => {
                            conditionOptionsSorted[conditionId] = version ? `${name} | ${version}` : name;
                        });
                });

                // Update selectOptions with our sorted values
                selectOptions = conditionOptionsSorted;
            }

            return (
                <div className="authoring-status-container">
                    {FEATURE_REPORTS_NAVBAR_UI === 'true' ? (
                        <ReportControlBar onBack={this.stepBack}>
                            {
                                <>
                                    {this.state.step === 'condition' &&
                                        this.state.reportContext.complete &&
                                        !this.state.reportContext.loading ? (
                                        <Button
                                            onClick={() => {
                                                this.setState({ displayState: 1 });
                                            }}
                                            hasIcon
                                            iconPosition={'left'}
                                            icon={`ios_share`}
                                        >
                                            Export
                                        </Button>
                                    ) : null}
                                </>
                            }
                        </ReportControlBar>
                    ) : null}
                    <div className="one-third">
                        <ReportController
                            user={this.props.userContext}
                            reportContext={this.state.reportContext}
                            onChange={this.change}
                            actions={actions}
                            stepLabel={`Select a ${this.state.step.charAt(0).toUpperCase() +
                                this.state.step.substr(1)}`}
                            value={this.state.reportContext[this.state.step]}
                            selectOptions={selectOptions}
                            displayContext={this.buildReportContext()}
                            isFixedOpen={FEATURE_REPORTS_NAVBAR_UI !== 'true'}
                        />
                    </div>
                    <div className="two-thirds">
                        {this.state.reportContext.complete &&
                            this.state.step === 'condition' &&
                            this.state.reportContext.condition != null && (
                                <ReportDisplay
                                    title="Condition Report"
                                    condition={this.state.reportContext.condition.label}
                                    jurisdiction={this.state.reportContext.jurisdiction.label}
                                    loading={this.state.reportContext.loading}
                                    reportSections={this.state.reportContext.sections}
                                />
                            )}
                    </div>
                </div>
            );
        } else {
            return (
                <div className="authoring-status-container">
                    {FEATURE_REPORTS_NAVBAR_UI === 'true' ? (
                        <ReportControlBar
                            onBack={() => {
                                this.setState({ displayState: 0 });
                            }}
                        >
                            <Button
                                onClick={() => {
                                    this.exportRef?.current?.print?.();
                                }}
                                hasIcon
                                iconPosition={'left'}
                                icon={`print`}
                            >
                                Print
                            </Button>
                            <Button
                                hasIcon
                                iconPosition={'left'}
                                icon={`file_download`}
                                onClick={() => {
                                    this.downloadExcelReport();
                                }}
                            >
                                Download .xlsx
                            </Button>
                        </ReportControlBar>
                    ) : null}
                    <ExportContainer
                        ref={this.exportRef}
                        title="Condition Details"
                        jurisdiction={this.state.reportContext.jurisdiction.label}
                        condition={this.state.reportContext.condition.label}
                        sections={this.state.reportContext.sections}
                        back={() => {
                            this.setState({ displayState: 0 });
                        }}
                    />
                </div>
            );
        }
    }
}

export default ConditionDetails;
